import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { UPDATE_LISTINGS_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import { updateListing } from 'modules/authorizations/store/actions/homesale.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';

const BrokerInfoCard = props => {
  const [isLoading, setIsLoading] = useState(false);

  const { listingInfo, brokerAgents, isReadOnly, id } = props;

  const brokerInfo = brokerAgents.find(a => a.vendorId === listingInfo?.brokerId);

  const tabs = [{ header: 'Broker Info', order: 1, iconPath: ['fas', 'person'] }];

  const searchingColumns = [
    { name: 'vendorId', title: 'Id' },
    { name: 'companyName', title: 'Company Name' }
  ];
  const searchingColumnExtensions = [
    { columnName: 'vendorId', width: 125 },
    { columnName: 'companyName', width: 150 }
  ];

  const brokerAgentSearchInfo = {
    searchingColumns: searchingColumns,
    searchingColumnExtensions: searchingColumnExtensions,
    searchingRows: brokerAgents,
    nameKey: 'companyName',
    idKey: 'vendorId'
  };

  const summaries = [
    {
      header: 'Broker',
      accessorKey: 'vendorId',
      nameKey: 'companyName',
      nameValue: brokerInfo ? brokerInfo.companyName : '',
      type: 'advanced-search',
      searchInfo: brokerAgentSearchInfo,
      required: true,
      value: listingInfo ? listingInfo.brokerId : '',
      tab: 1,
      hideInTable: true
    },

    {
      header: 'Broker Code',
      accessorKey: 'vendorCode',
      type: 'text',
      required: false,
      value: brokerInfo ? brokerInfo.vendorCode : '',
      hideInModal: true,
      tab: 1
    },
    {
      header: 'Broker Name',
      accessorKey: 'companyName',
      type: 'text',
      required: false,
      value: brokerInfo ? brokerInfo.companyName : '',
      hideInModal: true,
      tab: 1
    },
    {
      header: 'Broker Group',
      accessorKey: 'brokerGroup',
      type: 'text',
      required: false,
      value: brokerInfo ? brokerInfo.companyName : '',
      hideInModal: true,
      tab: 1
    },
    {
      header: 'Broker Email',
      accessorKey: 'officeEmail',
      type: 'text',
      required: false,
      value: brokerInfo ? brokerInfo.officeEmail : '',
      hideInModal: true,
      tab: 1
    },
    {
      header: 'Broker Phone',
      accessorKey: 'officePhone',
      type: 'text',
      required: false,
      value: brokerInfo ? brokerInfo.officePhone : '',
      hideInModal: true,
      tab: 1
    }
  ];

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    let newValues = { ...listingInfo };

    if (values.vendorId != null) {
      newValues.brokerId = values.vendorId;
    }

    const resp = await props.updateListing(newValues, id);
    if (resp.type === UPDATE_LISTINGS_FAILURE) {
      props.showToast('Failed to update broker info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      setIsLoading(false);
      return true;
    }
  };

  return (
    <EditableCard
      tabs={tabs}
      summaries={summaries}
      numColumns={5}
      updateFields={updateFields}
      isLoading={isLoading}
      smallerModal={true}
      hideEdit={isReadOnly}
    />
  );
};

export default compose(
  connect(null, {
    updateListing,
    showToast
  })
)(BrokerInfoCard);
